import { useTheme as useThemeContext } from '../contexts/ThemeContext';

// Re-export the hook for cleaner imports
export const useTheme = useThemeContext;

export default useTheme;